import React, { useState, useEffect } from "react";
import axios from "utils/axios";
import cookie from "react-cookies";
import { getDate } from "utils/utils";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

type Props = {
  org: string;
};

const OrganizationMain: React.FC<Props> = ({ org }) => {
  const [activities, setActivities] = useState<Array<any>>([]);
  const [accountCount, setAccoutCount] = useState<number>(0);
  const [clickCount, setClickCount] = useState<number>(0);
  const navigate = useNavigate();
  const { title: username } = cookie.load("user");

  useEffect(() => {
    org !== "" && getActivity(org);
  }, [org]);

  const getActivity = async (organization: string) => {
    let result = await axios.get(
      `/api/activity/getByOrganization/${organization}`
    );
    setActivities(result.data);
    result = await axios.get(`/api/resource/getClickCount/${organization}`);
    setClickCount(result.data?.count || 0);
    axios
      .post("/api/contract/getAllNFT", {
        contractId: process.env.REACT_APP_CONTRACT_ID,
      })
      .then((result) => {
        let count = 0;
        for (let nft of result.data) {
          nft.metadata.organization === organization && count++;
        }
        setAccoutCount(count);
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  return (
    <>
      <div className="bg-[#EDEDED] flex flex-wrap h-[190px] sm:h-72">
        <div className="w-1/3 flex flex-col gap-[8px] items-center justify-center text-center text-5xl text-main font-bold sm:w-1/2">
          {accountCount}
          <br />
          <span className="font-opensans font-light text-lg text-[#000] ">
            Accounts
          </span>
        </div>
        <div className="w-1/3 flex flex-col gap-[8px] items-center justify-center text-center text-5xl text-main font-bold sm:w-1/2">
          {clickCount}
          <br />
          <span className="font-opensans font-light text-lg text-[#000] ">
            Total Clicks
          </span>
        </div>
        <div className="w-1/3 flex flex-col gap-[8px] items-center justify-center text-center text-5xl text-main font-bold sm:w-1/2 sm:mx-auto">
          $0
          <br />
          <span className="font-opensans font-light text-lg text-[#000] ">
            Total Revenue
          </span>
        </div>
      </div>
      <div className="mt-[32px]">
        <h1 className="text-main sm:text-3xl mb-5">Activity Feed</h1>
        {activities.map((activity, index) => (
          <p
            className="text-lg font-opensans font-light leading-[40px]"
            key={index}
          >
            <span className="pr-2">{getDate(activity.date)}</span>
            <span
              className="pr-2 hover:text-[#3498db] cursor-pointer"
              onClick={() => {
                if (cookie.load("user")?.organization.toLowerCase() === "gyde")
                  navigate(`/profile/${activity.tokenId}`);
              }}
            >
              {activity.username === username ? "You" : activity.username}
            </span>
            <span className="pr-2">{activity.activityType}</span>
            <span
              className="pr-2 hover:text-[#3498db] cursor-pointer"
              onClick={() => {
                if (cookie.load("user")?.organization.toLowerCase() === "gyde")
                  navigate(`/view-resource?id=${activity.resourceId}`);
              }}
            >
              {activity.resourceName}
            </span>
            <span
              className="pr-2 hover:text-[#3498db] cursor-pointer"
              onClick={() => {
                if (cookie.load("user")?.organization.toLowerCase() === "gyde")
                  navigate(`/search/${activity.resourceType.toLowerCase()}`);
              }}
            >{`(${activity.resourceType})`}</span>
            {activity.rating && <span>{`with ${activity.rating} stars`}</span>}
          </p>
        ))}
      </div>
    </>
  );
};

export default OrganizationMain;
